var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.57 1.921v1.441c0 .113.094.206.206.206h1.656v16.867H3.562V3.565h1.655a.208.208 0 0 0 .207-.206V1.92a.206.206 0 0 0-.207-.207H2.533a.82.82 0 0 0-.822.822v18.93a.82.82 0 0 0 .822.822H21.46a.82.82 0 0 0 .822-.822V2.537a.82.82 0 0 0-.822-.822h-2.684a.206.206 0 0 0-.206.206zm-6.742-.498-3 3.8a.215.215 0 0 0 .169.349h2.036v8.41c0 .118.096.215.214.215h1.5a.215.215 0 0 0 .214-.214V5.572h2.036c.18 0 .281-.21.168-.348l-3-3.801a.215.215 0 0 0-.337 0z",
    fill: "#595959"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportFile);
export default __webpack_public_path__ + "static/media/export-file.1adf853a3684d622fe8991f06ec2074d.svg";
export { ForwardRef as ReactComponent };